const BadgesExtraCreditCodes = 
    [
        {badgeCode: "MMNT", badgeNbr: 1, topic: "Financial Literacy Basics", extraCreditCategory: "MoneyMgmt"},
        {badgeCode: "PRIOR", badgeNbr: 2, topic: "Needs vs. Wants (Priorities)", extraCreditCategory: "Priorities"},
        {badgeCode: "CHCAR", badgeNbr: 3, topic: "Choosing a Career", extraCreditCategory: "ChoosingCareer"},
        {badgeCode: "LBYM",  badgeNbr: 4, topic: "Living Below Your Means", 
            extraCreditCategory: "LivingBelowYourMeans"},
        {badgeCode: "LLOAN", badgeNbr: 5, topic: "Learning About Loans", 
            extraCreditCategory: "LearningAboutLoans"},
        {badgeCode: "Saving", badgeNbr: 6, topic: "Saving Money", extraCreditCategory: "SavingMoney"},
        {badgeCode: "INVEST", badgeNbr: 7, topic: "Investments", extraCreditCategory: "Investments"},
        {badgeCode: "INSURE", badgeNbr: 8, topic: "Insurance", extraCreditCategory: "Insurance"}
    ]

export default BadgesExtraCreditCodes;
